import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { Auth } from './../../auth/auth.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private auth: Auth) {}

  // we do not want to send Auth token to aws
  // otherwise, aws will return a 403 forbidden (CM).
  readonly REGION = 'us-east-1';
  // matches amazon aws URLs with or without region. Ex. "s3.amazonaws" and "s3.us-east-1.amazonaws"
  readonly AWS_URL_FRAGMENT_REGEX = new RegExp(`s3(\\.${this.REGION})?\\.amazonaws`);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const url = request && request.url;
    if (!url || this.AWS_URL_FRAGMENT_REGEX.test(url)) {
      return next.handle(request);
    }

    // A lapsed session rejects acquisition with SessionExpiredError, which
    // fails the request before it is sent; every other acquisition failure
    // resolves to null and the request goes out without the header. There is
    // deliberately no catchError here: errors must reach the caller untouched,
    // never trigger a re-send of the request.
    return from(this.auth.getBearerToken()).pipe(
      switchMap(token => {
        if (!token) return next.handle(request);
        const authorizedRequest = request.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        });
        return next.handle(authorizedRequest);
      }),
    );
  }
}
